import { AUTH } from "../contants/AUTH";
import { ROLES } from "../contants/ROLES";
import { KeyValuePair } from "../models/common/keyValuePair";

export class Helper {
    static isManager(): boolean {
        let role = localStorage.getItem(AUTH.userRole);
		if(role == ROLES.manager || role == ROLES.tracking){
			return true;
        }
        
        return false;
    }

    static isBookkeeper(): boolean {
        let role = localStorage.getItem(AUTH.userRole);
		return role == ROLES.bookKeeper;
    }

    static currentUserId(): number {
        return Number(localStorage.getItem(AUTH.userId));
    }

    static objectToKeyValuePair(object: any, includeNulls: boolean = false): KeyValuePair[] {
        var result: KeyValuePair[] = [];
        for(var prop in object){
            if(object[prop] != null){
                result.push({key: prop, value: object[prop]});
            }
            else if(includeNulls){
                result.push({key: prop, value: object[prop]});
            }
        }

        return result;
    }

    static areValuesNull(object: any): boolean {
        for(var prop in object){
            if(object[prop] != null || object[prop] != undefined){
                return false;
            }
        }

        return true;
    }

    static isNullOrUndefined(prop: any){
        if(prop == undefined || prop == null)
            return true;
        
        return false;
    }

    static countBy(arr, fn){
        return arr
            .map(typeof fn === 'function' ? fn : val => val[fn])
            .reduce((acc, val) => {
            acc[val] = (acc[val] || 0) + 1;
            return acc;
            }, {});
    }
        
}


// WEBPACK FOOTER //
// ./src/app/helpers/Helper.ts